import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {RootState} from '../store';
import {SelectPartnerById} from '../store/partnerManagerSlice';
import {RequestStatus} from '../store/network/managedRequest';
import {Outlet, useNavigate, useParams} from 'react-router-dom';
import {PbRequest} from '../store/pbRequest';

interface Props {
    selectedPartnerId: string;
    selectedPartnerStatus: RequestStatus;
    SelectPartnerById: (partnerId: string) => void;
}

function AccountingAreaRedirect(props: Readonly<Props>) {
    const params = useParams();
    const navigate = useNavigate();
    const targetAccountingAreaId = params.accounting_area_id;
    const selectedAccountingAreaId = props.selectedPartnerId;
    const requestStatus = props.selectedPartnerStatus;
    const targetPath = '/' + params['*'];

    useEffect(() => {
        if (!targetAccountingAreaId) {
            return;
        }
        if (targetAccountingAreaId !== selectedAccountingAreaId) {
            props.SelectPartnerById(targetAccountingAreaId);
        } else if (
            [RequestStatus.INITIAL, RequestStatus.SUCCESS].includes(
                requestStatus
            )
        ) {
            navigate(targetPath);
        }
    }, [
        targetAccountingAreaId,
        selectedAccountingAreaId,
        targetPath,
        requestStatus,
    ]);

    return <Outlet/>;
}

export default connect(
    (state: RootState) => ({
        selectedPartnerId: state.partnerManager.selectedPartnerId,
        selectedPartnerStatus:
            state.pbRequest[PbRequest.GET_SPECIFIC_PARTNER].status,
    }),
    { SelectPartnerById }
)(AccountingAreaRedirect);
